import { asyncFileRequestsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const FileRequestStatus = {
  NEW: 'New',
  IN_PROGRESS: 'InProgress',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
};

export const FILE_REQUEST_ACTION_TYPE = createNamedActions('fileRequest', {
  GET_FILE_REQUEST_STATUS: 'GET_FILE_REQUEST_STATUS',
});

export const getFileRequestStatusAction = catchAsyncActionError(id => async dispatch => {
  const { data } = await asyncFileRequestsApi.getAsyncFileRequest({ id });

  return dispatch({
    type: FILE_REQUEST_ACTION_TYPE.GET_FILE_REQUEST_STATUS,
    payload: data.status ?? {},
  });
});
